module.exports = __webpack_public_path__ + "img/کلاسیک.024a54f0.png";